import './CoralTeacherResourcesCards2.scss'

import { useIsWindowBiggerThan } from '@bob/library'
import { CoralMasterCardVisuals } from '@websrc/DataMappers/mapCoralMasterCard'
import { mapCoralWebTeacherResourcesCards2 } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { CoralMasterCard } from '../../../coral-library/cards/Coral/ContentCard/CoralMasterCard'

type CoralTeacherResourcesCards2Props = ReturnType<typeof mapCoralWebTeacherResourcesCards2>

export const CoralTeacherResourcesCards2: FC<CoralTeacherResourcesCards2Props> = (props) => {
  const visuals: CoralMasterCardVisuals = {
    subheadSize: 'body-md',
    headlineSize: 'h2-md',
    bodySize: 'body-sm',
    contentContainerColor: 'off-white',
    contentPadding: '3xl',
    imageOrientation: 'bottom',
    imageRatio: '2-1',
    imageBorder: true,
    paddingBody: 'lg',
    buttonIcon: 'arrow',
    buttonIconDirection: 'right',
    buttonIconDistance: true,
    buttonType: ['standalone-link'],
    buttonSize: 'lg',
    radius: 4,
  }
  const firstCardVisuals: CoralMasterCardVisuals = {
    subheadSize: 'body-md',
    headlineSize: 'h2-md',
    bodySize: 'body-sm',
    contentContainerColor: 'off-white',
    contentPadding: '3xl',
    buttonWidth: 'auto',
    imageOrientation: 'bottom',
    imageBorder: true,
    paddingBody: 'lg',
    buttonIconDirection: 'right',
    buttonIcon: 'arrow',
    buttonSize: 'lg',
    buttonType: ['standalone-link'],
    radius: 4,
  }

  const isDesktop = useIsWindowBiggerThan(1079)

  const firstCard = isDesktop
    ? {
        ...props.cards[0],
        asset: props.cards[0].large_asset ?? props.cards[0].asset,
      }
    : props.cards[0]
  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-teacher-resources-cards-2'}>
        {isDesktop && (
          <div className={`coral-teacher-resources-cards-2__header-item`}>
            <CoralMasterCard {...firstCard} visuals={firstCardVisuals} />
          </div>
        )}
        <div className={`coral-teacher-resources-cards-2__list`}>
          {props.cards.slice(isDesktop ? 1 : 0).map((card, index) => (
            <div className={`coral-teacher-resources-cards-2__item`} key={index}>
              <CoralMasterCard {...card} visuals={visuals} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
